export default "__VITE_PUBLIC_ASSET__9c99208a__"